
<template>
    <div class="public_container add_approval_wrap">
        <div class="returnNavBar">
            <ReturnNavBar title="返回" :isTitleNormal="true" :isAllFunctions="true"></ReturnNavBar>
        </div>
        <div class="purchase_add_container mobile_container"  v-loading="loading">
            <van-form ref="purchaseFormData"
                      input-align="right"
                      label-width="10em"
                      scroll-to-error>
                <van-field :value="purchaseFormData.purchase_num"  label="采购单编号" readonly ></van-field>
                <van-field :value="purchaseFormData.supplier_name"  label="供应商" readonly ></van-field>


                <div class="return_details_wrap">
                    <div class="return_details_title">
                        <span class="return_details_title_name">退货产品明细</span>
                    </div>
                    <div class="return_details_list">
                        <div class="return_details_list_item" v-for="(item,index) in purchaseFormData.return_details" :key="index">
                            <i class="el-icon-error"   @click="purchaseFormData.return_details.splice(index,1);handleCountPurchaseTotalPrice(item)"></i>
                            <div class="field_wrap">
                                <van-popover v-if="!item.id" :get-container="getContainerPurchaseDetails" v-model="item.productPopoverShow"  style="left: 0 !important;" :show-arrow="false" :offset="[0,0]" trigger="click" placement="bottom-start">
                                    <div class="productItemBox" v-if="productAllList.filter(find => find.product_name.includes(item.product_name)).length>0">
                                        <div class="product_item flex_js_wrap" v-if="purchaseFormData.return_details.find(find => find.id == list.id) ? false : true" v-for="list in productAllList.filter(find => find.product_name.includes(item.product_name))" @click="handleClickSelectProduct(item,list)">
                                            <div class="product_name ellipsis">{{ list.product_name }}</div>
                                        </div>
                                    </div>
                                    <template #reference>
                                        <van-field v-model="item.product_name" required @blur="handleBlurProduct(item)" label="退货产品" placeholder="请选择/请输入" ></van-field>
                                    </template>
                                </van-popover>
                                <van-field v-else v-model="item.product_name" required readonly  label="退货产品" placeholder="" ></van-field>
                            </div>
                            <div class="field_wrap">
                                <van-field v-model="item.num" required @input="handleCountPurchaseTotalPrice(item)" type="digit" label="退货数量" placeholder="请输入"></van-field>
                            </div>
                            <div class="field_wrap">
                                <van-field v-model="item.price" required readonly type="number"   label="单价（元)"  placeholder="请输入"></van-field>
                            </div>
                            <div class="field_wrap">
                                <van-field v-model="item.total_price" readonly    label="小计金额（元）"  placeholder="系统计算"></van-field>
                            </div>

                            <div class="field_wrap vertical_input_wrap"  >
                                <van-field v-model="item.none" label="退货说明"  placeholder="请输入" type="textarea"></van-field>
                            </div>
                        </div>
                    </div>

                    <div class="return_details_add" v-if="purchaseFormData.return_details.length != productAllList.length">
                       <span @click="handleClickPurchaseReturnAdd()">
                            <i class="el-icon-plus"></i> 新增行
                       </span>
                    </div>
                </div>
                <div class="field_item">
                    <div class="field_name">附件</div>
                    <div class="field_content">
                        <div class="file_list" v-if="purchaseFormData.files && purchaseFormData.files.length>0">
                            <ul>
                                <li v-for="(file, file_idx) in purchaseFormData.files" :key="file_idx">
                                    <p class="ellipsis" v-text="file.file_name"></p>
                                    <div>
                                        <span @click="handleClickPreview(file)"><i class="iconfont icon-yanjing"></i></span>
                                        <span @click="purchaseFormData.files.splice(file_idx,1)"><i class="iconfont icon-shanchu1"></i></span>
                                    </div>
                                </li>
                            </ul>
                        </div>
                        <div class="file_note" v-else>支持.rar .zip .doc .docx .pdf .jpg...</div>
                        <div class="file_upload">
                            <input class="upload_input"  multiple type="file" @change="handleUploadFileChange($event)">
                            <i class="iconfont icon-upload"></i>上传附件
                        </div>

                    </div>
                </div>
                <div class="field_item">
                    <div class="field_name">备注信息</div>
                    <div class="field_content">
                        <van-field
                                v-model="purchaseFormData.note"
                                rows="3"
                                input-align="left"
                                autosize
                                label=""
                                type="textarea"
                                placeholder="请输入备注信息"
                        />
                    </div>
                </div>

            </van-form>

            <div class="add_approval_select_process">
                <approveProcessSelect ref="approveProcessSelectRef" :approval_node_list="approval_node_list"></approveProcessSelect>
            </div>
        </div>
        <div class="add_footer_wrap">
            <van-button round block type="info" :disabled="btnDisabled" @click="handleClickConfirm">提交</van-button>
        </div>

    </div>
</template>

<script>
import {PurchaseReturnDetail,getApprovalNodes,PurchaseReturn} from "@/api";
import {getOSSData, uploadImg} from "@/utils/uploadOss";
import {formatFileSize} from "@/utils";
import ReturnNavBar from "@/components/mComponents/ReturnNavBar.vue";
import approveProcessSelect from "@/components/mComponents/approveProcessSelect";
import {ImagePreview} from "vant";
export default {
    name: "purchase_return_goods",
    components: {ReturnNavBar,approveProcessSelect},
    data() {
        return {
            loading: false,
            btnDisabled: false,
            approval_node_list:[],
            purchaseId:0,
            purchaseFormData: {
                supplier_name:'',
                purchase_num:'',
                return_details:[],
                total_num:0,
                total_price:'',
                files:[],
                note:'',
            },
            purchaseFormDataRules:{

            },
            productAllList:[]
        };
    },
    created() {
        this.purchaseId = Number(this.$route.query.purchase_id)
        this.getApprovalNodes()
        this.getPurchaseReturnDetail()
    },
    methods: {

        // 获取审批流
        getApprovalNodes(only = false){
            this.approval_node_list = []
            getApprovalNodes({
                approval_type: 'purchase_return',
            }).then(res => {
                if (res.code === 200) {
                    this.approval_node_list = res.data
                    this.$refs.approveProcessSelectRef.set_approval_node_list(res.data)
                } else {
                    this.$message.error(res.message)
                }
                this.loading = false
            }).catch(() => {
                this.loading = false
            })
        },
        // 获取
        getPurchaseReturnDetail(){
            PurchaseReturnDetail({
                purchase_id: this.purchaseId
            }).then(res => {
                if (res.code === 200) {
                    this.purchaseFormData.supplier_name = res.data.supplier_name
                    this.purchaseFormData.purchase_num = res.data.purchase_num

                    res.data.purchase_details.forEach(item=>{
                        this.$set(item,'max_num',item.num)
                    })
                    this.purchaseFormData.return_details = res.data.purchase_details
                    this.productAllList = JSON.parse(JSON.stringify(res.data.purchase_details))
                    this.handleCountPurchaseTotalPrice()
                } else {
                    this.$message.error(res.message)
                }
                this.loading = false
            }).catch(() => {
                this.loading = false
            })
        },

        // 上传附件
        handleUploadFileChange(e){
            const files = e.target.files
            const that = this;
            Array.from(files).forEach(file => {
                uploadImg(file, 50).then(res => {
                    if (res.file_path) {
                        res.file_size = formatFileSize(file.size)
                        this.purchaseFormData.files.push(res)
                        e.target.value = ''
                    }
                    e.target.value = ''
                }).catch(error => {
                    e.target.value = ''
                })
            })
        },
        // 预览
        handleClickPreview(file){
            if (file.file_type && file.file_type.indexOf("image") > -1) {
                ImagePreview({
                    images: [file.file_path],
                    startPosition: 0,
                });
            } else {
                if (file.file_type && file.file_type.indexOf("pdf") > -1) {
                    window.open(file.file_path);
                } else {
                    this.$toast("当前文件格式不支持预览，请下载后查看");
                }
            }
        },

        getContainerPurchaseDetails() {
            return  document.querySelector('.return_details_wrap')
        },

        // 输入产品名称失去焦点
        handleBlurProduct(item){
            let info  = this.productAllList.find(find => find.product_name == item.product_name)
            if(info){
                this.handleClickSelectProduct(item,info)
            }
        },
        // 选中产品
        handleClickSelectProduct(item,list){
            for (let infoKey in list) {
                this.$set(item,infoKey,list[infoKey])
            }
            this.$set(item,'note','')
            this.$set(item,'productPopoverShow',false)
            this.handleCountPurchaseTotalPrice()
        },
        // 采购计算金额
        handleCountPurchaseTotalPrice(item) {
            if(item){
                if(item.num > item.max_num){
                    this.$set(item,'num', item.max_num)
                }
                this.$set(item,'total_price',Number(item.num) * Number(item.price))
            }
            let total_price = 0
            let total_num  = 0
            this.purchaseFormData.return_details.forEach(item=>{
                total_price += item.total_price ?  Number(item.total_price) :0
                total_num += item.num ?  Number(item.num) :0
            })
            this.$set(this.purchaseFormData, 'total_num', total_num)
            this.$set(this.purchaseFormData, 'total_price', total_price)
        },
        // 新增行
        handleClickPurchaseReturnAdd(){
            let json = {
                purchase_id:'',
                id:'',
                product_name:'',
                num:'',
                stock_id:'',
                price:'',
                total_price:'',
                sku_id:'',
                sku_key:'',
                note:''
            }
            this.purchaseFormData.return_details.push(json)
        },
        handleClickConfirm() {
            if(this.$refs.approveProcessSelectRef.handleClickPublish() == false){  //审批节点校验没通过
                return false
            }

            let return_details = []
            this.purchaseFormData.return_details.forEach(item=>{
                if(item.num){
                    let json = {
                        id: item.id,
                        purchase_id: item.purchase_id,
                        product_name:  item.product_name,
                        sku_id:  item.sku_id,
                        sku_key:  item.sku_key,
                        num: item.num,
                        price: item.price,
                        total_price: item.total_price,
                        note:  item.note,
                    }
                    return_details.push(json)
                }

            })
            if(return_details.length  == 0){return  this.$message.error('请至少退一个产品')}
            let postData = {
                purchase_id: this.purchaseId,
                supplier_name: this.purchaseFormData.supplier_name,
                purchase_num:  this.purchaseFormData.purchase_num,
                return_details:return_details,
                total_num:this.purchaseFormData.total_num,
                total_price:this.purchaseFormData.total_price,
                files:this.purchaseFormData.files,
                note:this.purchaseFormData.note,
                node_list:this.approval_node_list
            }
            this.BtnDisabled = true;
            PurchaseReturn(postData).then(res => {
                if (res.code === 200) {
                    this.$toast({
                        message: res.message,
                        type: "success",
                        duration: 1000,
                        onClose: () => {
                            this.$router.go(-1);
                            this.BtnDisabled = false;
                        },
                    });
                } else {
                    this.$toast({
                        message: res.message,
                        type: "fail",
                    });
                    this.BtnDisabled = false;
                }
            }).catch(() => {
                this.BtnDisabled = false;
            })
        },



    },
};
</script>

<style lang="scss" scoped>
.custom_form_wrap{
    height: auto;
}
.purchase_add_container{
    width: 100%;
    padding: 10px 0;
    box-sizing: border-box;
    background: #fff;
    .field_item{
        width: 100%;
        border-top: 1px solid rgba(247, 248, 250, 1);
        padding: 10px 16px;
        box-sizing: border-box;

        .field_name{
            width: 100%;
            line-height: 22px;
            font-size: 14px;
            color: rgba(51, 51, 51, 1);
            margin-bottom: 4px;
        }
        .field_content{
            width: 100%;
            .van-cell{
                padding:0 0 4px 0;
            }
            ::v-deep .van-cell--required::before{
                position: initial;
                margin-right: 2px;
            }
            .file_list{
                width: 100%;
                ul{
                    width: 100%;
                    li{
                        width: 100%;
                        margin-bottom: 10px;
                        border-radius: 2px;
                        background: rgba(249, 249, 249, 1);
                        border: 1px solid rgba(217, 217, 217, 1);
                        line-height: 20px;
                        padding: 0 8px;
                        box-sizing: border-box;
                        display: flex;
                        justify-content: space-between;
                        align-items: center;
                        p{
                            width: calc(100% - 50px);
                            font-size: 12px;
                            color: rgba(102, 102, 102, 1);
                        }
                        div{
                            width: 48px;
                            span{
                                width: 16px;
                                margin-left: 8px;
                                text-align: center;
                                line-height: 16px;
                            }
                            i{
                                font-size: 14px;
                                color: rgba(102, 102, 102, 1);
                            }
                        }
                    }
                }
            }
            .file_note{
                font-size: 12px;
                color: rgba(153, 153, 153, 1);
                line-height: 18px;
                margin-bottom: 34px;
            }
            .file_upload{
                width: 100px;
                position: relative;
                line-height: 22px;
                margin: 0 auto;
                color: rgba(25, 144, 255, 1);
                font-size: 14px;
                text-align: center;
                i{
                    margin-right: 8px;
                }
                input{
                    position: absolute;
                    left: 0;
                    top: 0;
                    width: 100%;
                    height: 100%;
                    opacity: 0;
                }
            }

        }
    }
    .vertical_input_wrap {
        ::v-deep .van-cell {
            display: block;

            .van-cell__value {
                text-align: left;
                margin-top: 4px;

                .van-field__control--right {
                    text-align: left;
                }
            }

            .van-field__control--custom {
                display: block;
            }
        }
    }
    .return_details_wrap{
        width: 100%;
        padding: 10px 16px 0;
        box-sizing: border-box;
        background: #fff;
        .return_details_title{
            line-height: 22px;
            display: flex;
            justify-content: space-between;
            align-items: center;
            .return_details_title_name{
                color: rgba(153, 153, 153, 1);
                font-size: 14px;
            }
        }
        .return_details_list{
            width: 100%;
            .return_details_list_item{
                width: 100%;
                border-radius: 8px;
                margin-top: 8px;
                padding: 0 10px;
                box-sizing: border-box;
                background: rgba(247, 248, 250, 1);
                position: relative;
                .field_wrap{
                    border-bottom: 1px solid rgba(232, 232, 232, 1);
                    box-sizing: border-box;
                    &:last-child{
                        border-bottom: 0;
                    }
                }
                .van-cell{
                    padding-left: 0;
                    padding-right: 0;
                    background: rgba(247, 248, 250, 1);
                }
                ::v-deep .van-cell--required::before{
                    left: -6px;
                }
                .el-icon-error{
                    position: absolute;
                    right:0;
                    top: -3px;
                    z-index: 10;
                    color: rgba(153, 153, 153, 1) ;
                }
            }
        }
        .return_details_add{
            text-align: center;
            line-height: 22px;
            padding: 10px;
            box-sizing: border-box;
            color: rgba(25, 144, 255, 1);
            i{
                margin-right: 4px;
            }
        }
    }
    .return_details_wrap ::v-deep .van-popover[data-popper-placement="bottom-start"] .van-popover__arrow{
        display: none !important;
    }

    .productItemBox{
        width: calc(100vw - 56px);
        padding: 8px 2px;
        box-sizing: border-box;
        max-height: 220px;
        overflow-y: auto;
        .product_item{
            width: 100%;
            line-height: 30px;
            padding: 0 12px;
            color: rgba(102, 102, 102, 1);
            &:active{
                color: rgba(102, 102, 102, 1);
                background: rgba(0, 0, 0, 0.04);
            }
            .product_name {
                display: block;
                width: calc(100% - 50px);
            }
            .product_tag {
                width: 40px;
                height: 22px;
                opacity: 1;
                border-radius: 4px;
                background: rgba(240, 170, 50, 0.1);
                line-height: 22px;
                font-size: 12px;
                color: rgba(240, 170, 50, 1);
                text-align: center;
            }
        }

    }
}

.add_footer_wrap {
    padding: 5px 16px;
    background-color: #f7f8fa;

    .van-button {
        border-radius: 8px;
        height: 38px;
        background-color: rgba(41, 144, 240, 1);
        border-color: rgba(41, 144, 240, 1);
    }
}
.add_approval_select_process{
    padding: 10px 16px;
    background: #fff;
}
</style>
